import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { logout } from "../../redux/actions/authActions";


const events = [
  "load",
  "mousemove",
  "mousedown",
  "click",
  "scroll",
  "keypress",
];

const AppLogout = ({ children }) => {
    let timer;
    const dispatch = useDispatch()

useEffect(() => {
  Object.values(events).forEach((item) => {
    window.addEventListener(item, () => {
      resetTimer();
      handleTimer();
    });
  });
}, []);

const resetTimer = () => {
  if (timer) clearTimeout(timer);
};

const handleTimer = () => {
  timer = setTimeout(() => {
    resetTimer();
    Object.values(events).forEach((item) => {
      window.removeEventListener(item, resetTimer);
    });
    
      logoutAction();
      
  }, 1000 * 60 * 60 * 24 * 10);
};

const logoutAction = () => {
    dispatch(logout());
};
  return children;
};

export default AppLogout;